import React from 'react';
import Icons from 'bootstrap-italia/dist/svg/sprite.svg';

export default ({ name, color, classiAggiuntive, ...otherProps }) => (
  <svg role="img" aria-hidden={"true"} className={`icon ${classiAggiuntive ? classiAggiuntive : ''}`} style={{ fill: color }} {...otherProps}>
    <use xlinkHref={`${Icons}#it-${name}`} />
  </svg>
);
